<template>
  <button
    type="button"
    class="flex w-full items-center justify-between rounded-2xl bg-white p-4"
    @click="$emit('onBottomSheetOpen')"
  >
    <p class="text-sm font-medium">
      {{ title }}
    </p>
    <img
      height="24"
      width="24"
      src="@/assets/images/green-info-icon.svg"
      :alt="t('ancillaries.medicalInsurance.showConditions')"
    />
  </button>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  defineProps<{
    title: string;
  }>();

  const { t } = useI18n();
</script>
